import {EDIT_MESSAGE_SUCCESS} from "../../reducers/editMessageReducer";


export const editMessageSuccess = (message) =>{

    return {
        type: EDIT_MESSAGE_SUCCESS,
        payload: {message}
    }
}